import React from "react";
import { OffersList } from "./OffersList";

import { OffersListProps } from "./Props";

import { useRecoilValue } from "recoil";
import { searchFormSelector } from "../../../state/search-state";

type EnsureDatesEnabledProps = {
  children: React.ReactNode;
};

const EnsureDatesEnabled: React.FC<EnsureDatesEnabledProps> = ({ children }) => {
  const filtersValue = useRecoilValue(searchFormSelector);
  const { dateRange } = filtersValue;
  const [arrivalDate, departureDate] = dateRange;

  if (arrivalDate && departureDate) {
    return <>{children}</>;
  }

  return null;
};

export const OffersListWidget = (props: OffersListProps) => {
  const { type, forcedArrivalDate, forcedDepartureDate } = props;
  if (type === "future" || (forcedArrivalDate && forcedDepartureDate)) {
    return <OffersList {...props} />;
  }
  return (
    <EnsureDatesEnabled>
      <OffersList {...props} />
    </EnsureDatesEnabled>
  );
};
